export const BreakpointSmDefault = 360;
export const BreakpointSmMin = 0;
export const BreakpointSmMax = 767;
export const BreakpointMdDefault = 768;
export const BreakpointMdMin = 768;
export const BreakpointMdMax = 1023;
export const BreakpointLgDefault = 1280;
export const BreakpointLgMin = 1024;
export const BreakpointLgMax = 1439;
export const BreakpointXlDefault = 1440;
export const BreakpointXlMin = 1440;
export const BreakpointXlMax = 1920;
export const ColorNeutral50 = "#F6F6F6";
export const ColorNeutral100 = "#E6E7E7";
export const ColorNeutral200 = "#D1D1D1";
export const ColorNeutral300 = "#B0B0B0";
export const ColorNeutral400 = "#888888";
export const ColorNeutral500 = "#6D6D6D";
export const ColorNeutral600 = "#5D5D5D";
export const ColorNeutral700 = "#4F4F4F";
export const ColorNeutral800 = "#454545";
export const ColorNeutral900 = "#3D3D3D";
export const ColorNeutral950 = "#1A1A1A";
export const ColorNeutralWhite = "#FFFFFF";
export const ColorNeutralBlack = "#1A1A1A";
export const ColorNeutralTransparent = "transparent";
export const ColorOpacityOnLight50 = "#1A1A1A0A";
export const ColorOpacityOnLight100 = "#1A1A1A1A";
export const ColorOpacityOnLight200 = "#1A1A1A31";
export const ColorOpacityOnLight300 = "#1A1A1A43";
export const ColorOpacityOnLight400 = "#1A1A1A66";
export const ColorOpacityOnLight500 = "#1A1A1A94";
export const ColorOpacityOnLight600 = "#1A1A1AAE";
export const ColorOpacityOnLight700 = "#1A1A1AC5";
export const ColorOpacityOnLight800 = "#1A1A1AD0";
export const ColorOpacityOnLight900 = "#1A1A1ADB";
export const ColorOpacityOnLight950 = "#1A1A1A";
export const ColorOpacityOnDark50 = "#FFFFFFFa";
export const ColorOpacityOnDark100 = "#FFFFFF1a";
export const ColorOpacityOnDark200 = "#FFFFFF33";
export const ColorOpacityOnDark300 = "#FFFFFF57";
export const ColorOpacityOnDark400 = "#FFFFFF85";
export const ColorOpacityOnDark500 = "#FFFFFFa3";
export const ColorOpacityOnDark600 = "#FFFFFFb5";
export const ColorOpacityOnDark700 = "#FFFFFFc4";
export const ColorOpacityOnDark800 = "#FFFFFFcf";
export const ColorOpacityOnDark900 = "#FFFFFFd9";
export const ColorOpacityOnDark950 = "#FFFFFF";
export const ColorSystemSuccess50 = "#F3FBF2";
export const ColorSystemSuccess100 = "#DFF5DD";
export const ColorSystemSuccess200 = "#C9ECC6";
export const ColorSystemSuccess300 = "#9CDD98";
export const ColorSystemSuccess400 = "#6AC464";
export const ColorSystemSuccess500 = "#45A83F";
export const ColorSystemSuccess600 = "#32852D";
export const ColorSystemSuccess700 = "#0B6D28";
export const ColorSystemSuccess800 = "#275724";
export const ColorSystemSuccess900 = "#21481F";
export const ColorSystemSuccess950 = "#0D270C";
export const ColorSystemWarning50 = "#FEFAEC";
export const ColorSystemWarning100 = "#FBEFC6";
export const ColorSystemWarning200 = "#F7E090";
export const ColorSystemWarning300 = "#F3CA56";
export const ColorSystemWarning400 = "#E4A410";
export const ColorSystemWarning500 = "#CD8313";
export const ColorSystemWarning600 = "#AE600E";
export const ColorSystemWarning700 = "#984710";
export const ColorSystemWarning800 = "#803A13";
export const ColorSystemWarning900 = "#6D3013";
export const ColorSystemWarning950 = "#421906";
export const ColorSystemError50 = "#FEF2F2";
export const ColorSystemError100 = "#FEE2E2";
export const ColorSystemError200 = "#FDCBCB";
export const ColorSystemError300 = "#FBA6A6";
export const ColorSystemError400 = "#F88B8B";
export const ColorSystemError500 = "#ED4646";
export const ColorSystemError600 = "#DA2828";
export const ColorSystemError700 = "#B71E1E";
export const ColorSystemError800 = "#981C1C";
export const ColorSystemError900 = "#7E1E1E";
export const ColorSystemError950 = "#440B0B";
export const FontSize10 = "0.7142857142857143rem";
export const FontSize12 = "0.8571428571428571rem";
export const FontSize14 = "1rem";
export const FontSize16 = "1.1428571428571428rem";
export const FontSize18 = "1.2857142857142858rem";
export const FontSize20 = "1.4285714285714286rem";
export const FontSize24 = "1.7142857142857142rem";
export const FontSize28 = "2rem";
export const FontSize32 = "2.2857142857142856rem";
export const FontSize40 = "2.857142857142857rem";
export const FontSize48 = "3.4285714285714284rem";
export const FontSize56 = "4rem";
export const FontSize64 = "4.571428571428571rem";
export const FontSize80 = "5.714285714285714rem";
export const FontSize96 = "6.857142857142857rem";
export const FontWeightThin = 100;
export const FontWeightExtraLight = 200;
export const FontWeightLight = 300;
export const FontWeightRegular = 400;
export const FontWeightMedium = 500;
export const FontWeightSemibold = 600;
export const FontWeightBold = 700;
export const FontWeightExtraBold = 800;
export const FontWeightBlack = 900;
export const FontLineHeightNone = 1;
export const FontLineHeightTight = 1.2;
export const FontLineHeightNormal = 1.5;
export const SizeSpacing2 = "2px";
export const SizeSpacing4 = "4px";
export const SizeSpacing6 = "6px";
export const SizeSpacing8 = "8px";
export const SizeSpacing12 = "12px";
export const SizeSpacing16 = "16px";
export const SizeSpacing20 = "20px";
export const SizeSpacing24 = "24px";
export const SizeSpacing28 = "28px";
export const SizeSpacing32 = "32px";
export const SizeSpacing40 = "40px";
export const SizeSpacing48 = "48px";
export const SizeSpacing56 = "56px";
export const SizeSpacing64 = "64px";
export const SizeSpacing72 = "72px";
export const SizeSpacing80 = "80px";
export const SizeSpacing88 = "88px";
export const SizeSpacing96 = "96px";
export const SizeSpacing104 = "104px";
export const SizeSpacing112 = "112px";
export const SizeSpacing120 = "120px";
export const SizeRadius4 = "4px";
export const SizeRadius8 = "8px";
export const SizeRadius16 = "16px";
export const SizeRadiusNone = "0px";
export const SizeRadiusFull = "100vw";
export const SizeRadiusStrokeDefault = "1px";
export const SizeRadiusStrokeFocus = "2px";
export const SizeIconXSmall = "16px";
export const SizeIconSmall = "20px";
export const SizeIconMedium = "24px";
export const SizeIconLarge = "32px";
export const SizeIconXLarge = "48px";
export const SizeIconXxLarge = "64px";
export const SizeRatingIconSmall = "12px";
export const SizeRatingIconMedium = "16px";
export const SizeRatingIconLarge = "24px";
